// Auxiliary presentational metadata for peptides. Prices used to live here but
// have moved fully into the products collection (via product.variants[]).
// This file now only keeps short blurbs used on the catalog cards.
export const PEPTIDE_META = {
  "bpc-157": { blurb: "Tissue repair & joint recovery research." },
  "tb-500": { blurb: "Systemic soft-tissue regeneration studies." },
  "tesamorelin": { blurb: "GH-axis & lipid metabolism research." },
  "semax": { blurb: "Neuroplasticity & BDNF pathway research." },
  "cjc-1295": { blurb: "GH pulse amplification research." },
  "ipamorelin": { blurb: "Selective GH secretagogue studies." },
  "melanotan-ii": { blurb: "Melanocortin & appetite research." },
  "ghk-cu": { blurb: "Skin, coat, and collagen research." },
};

export const meta = (slug) => PEPTIDE_META[slug] || { blurb: "" };

export const CATEGORY_INFO = {
  Recovery: {
    title: "Recovery",
    tagline: "Soft-tissue, joint, and cellular repair pathways.",
    image: "https://images.unsplash.com/photo-1514373941175-0a141072bbc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxkb2clMjBydW5uaW5nJTIwaGVhbHRoeXxlbnwwfHx8fDE3ODQzNTkwMDN8MA&ixlib=rb-4.1.0&q=85",
  },
  Metabolic: {
    title: "Metabolic",
    tagline: "GH axis, lipid, and energy-metabolism research.",
    image: "https://images.pexels.com/photos/7474859/pexels-photo-7474859.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  Cognitive: {
    title: "Cognitive",
    tagline: "Neurogenesis, BDNF, and cognitive-endurance research.",
    image: "https://images.unsplash.com/photo-1656331797721-b593b8f00297?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxtb2xlY3VsZSUyMHN0cnVjdHVyZSUyMG1lZGljYWx8ZW58MHx8fHwxNzg0MzU5MDAzfDA&ixlib=rb-4.1.0&q=85",
  },
};
